export type ApplicationType = 'epe' | 'service1' | 'service2' | 'service3';
export type ApplicationStatus = 'pending' | 'eligible' | 'not_eligible' | 'voted' | 'proactive';

export class Application {
  [index: string]: any
  _id?: string
  user_id?: number
  application_type?: ApplicationType
  status?: ApplicationStatus
  form_data?: EpeFormData | ProjectFormData
  created_at?: string
  updated_at?: string
}

export class EpeFormData {
  [index: string]: any
  topics?: object[] = []
  standardisation_roles?: object[] = []
  academic_qualifications?: object[] = []
  cv?: string
  linkedin?: string
  position?: string
  position_dates?: string
  previous_positions?: object[] = []
  tell_us_more?: string
  website_publication?: boolean
  title?: string
  gender?: string
  organisation?: string
  organisation_type?: string
  country?: string
  phone_number?: string
}

export class ProjectFormData {
  [index: string]: any
  project_acronym?: string
  full_project_name?: string
  funding_programme?: string
  other_funding_programme?: string
  grant_agreement?: string
  topics?: object[] = []
  project_short_description?: string
  objectives_standardisation?: string
  why_the_project_applying?: string
  information_to_attain?: string[] = []
  standard_reference?: object[] = []
  related_doc_application?: object[] = []
  website_publication?: boolean
  title?: string
  organisation?: string
  country?: string
}

export const APPLICATION_TYPE_LABELS: Record<ApplicationType, string> = {
  epe: 'EPE Application',
  service1: 'Service 1',
  service2: 'Service 2',
  service3: 'Service 3',
};

export const STATUS_COLORS: Record<ApplicationStatus, string> = {
  pending: '#f39c12',
  eligible: '#2ecc71',
  not_eligible: '#e74c3c',
  voted: '#3498db',
  proactive: '#9b59b6',
};
